import { message } from "antd";
import HBIcon from "../HBIcon";
import styles from "./index.module.less";

const HBMessage = {
  success(content, duration, onClose) {
    if (typeof window === "undefined") {
      return;
    }

    if (typeof content === "string") {
      if (typeof duration === "function") {
        onClose = duration;
        duration = 3;
      }
      return message.success({
        className: styles.message,
        icon: <HBIcon type="ic_check_circle" />,
        content,
        duration,
        onClose,
      });
    } else {
      return message.success({
        className: styles.message,
        icon: <HBIcon type="ic_check_circle" />,
        ...content,
      });
    }
  },
  error(content, duration, onClose) {
    if (typeof window === "undefined") {
      return;
    }
    if (typeof content === "string") {
      if (typeof duration === "function") {
        onClose = duration;
        duration = 3;
      }
      return message.error({
        className: styles.message,
        icon: <HBIcon type="ic_alert" />,
        content,
        duration,
        onClose,
      });
    } else {
      return message.error({
        className: styles.message,
        icon: <HBIcon type="ic_alert" />,
        ...content,
      });
    }
  },
  info(content, duration, onClose) {
    if (typeof window === "undefined") {
      return;
    }
    if (typeof content === "string") {
      if (typeof duration === "function") {
        onClose = duration;
        duration = 3;
      }
      return message.info({
        className: styles.message,
        icon: <HBIcon type="ic_info" />,
        content,
        duration,
        onClose,
      });
    } else {
      return message.info({
        className: styles.message,
        icon: <HBIcon type="ic_info" />,
        ...content,
      });
    }
  },
  open(content, duration, onClose) {
    if (typeof window === "undefined") {
      return;
    }
    if (typeof content === "string") {
      if (typeof duration === "function") {
        onClose = duration;
        duration = 3;
      }
      return message.open({
        className: styles.message,
        content,
        duration,
        onClose,
      });
    } else {
      return message.open({
        className: styles.message,
        ...content,
      });
    }
  },
};

export default HBMessage;
